import { BaseRequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class RequestOptionsService extends BaseRequestOptions {
	constructor() {
		super();
		this.headers.set('Content-Type', 'application/json');
	}
}
